
export const API = {
    get: async(accessToken: string, path: string, query?: string[]) => {
        const response =  await fetch(`${process.env.REACT_APP_GOOGLE_ACCESS_POLICY_API_BASE}${path}${query && query.length ? '?'+query.join('&') : ''}`, {
            method: 'GET',
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            },
        })
        return response;
    },
    post: async(accessToken: string, path: string, body: any) => {
        const response =  await fetch(`${process.env.REACT_APP_GOOGLE_ACCESS_POLICY_API_BASE}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        })
        return response;
    }
}